import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';
import { useFormContext } from '../../../context/FormContext';
import { Input } from '../../ui/Input';
import { Button } from '../../ui/Button';
import { RadioGroup } from '../../ui/Radio';

const { FiPlus, FiTrash2 } = FiIcons;

export const AssetsSection = () => {
  const { data, updateFormSection } = useFormContext();
  const assets = data.form.assets;

  const addAsset = () => {
    updateFormSection('assets', [
      ...assets,
      { id: Date.now(), name: '', dateAcquired: '', cost: '', supplier: '', isNew: 'yes', notes: '' }
    ]);
  };

  const removeAsset = (id) => updateFormSection('assets', assets.filter(a => a.id !== id));
  const updateField = (id, field, value) => updateFormSection('assets', assets.map(a => a.id === id ? { ...a, [field]: value } : a));

  return (
    <div className="space-y-6">
      {assets.map((a, index) => (
        <div key={a.id} className="p-6 border border-brand-border rounded-2xl bg-brand-light/20 shadow-sm">
          <div className="flex justify-between items-center mb-6">
            <h4 className="text-sm font-bold text-brand-text uppercase tracking-tight">Asset #{index + 1}</h4>
            {assets.length > 1 && (
              <button onClick={() => removeAsset(a.id)} className="text-brand-muted hover:text-red-500 transition-colors">
                <SafeIcon icon={FiTrash2} />
              </button>
            )}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
            <Input label="Asset Name" value={a.name} onChange={e => updateField(a.id, 'name', e.target.value)} />
            <Input label="Acquisition Cost" type="number" value={a.cost} onChange={e => updateField(a.id, 'cost', e.target.value)} />
            <Input label="Date Acquired" type="date" value={a.dateAcquired} onChange={e => updateField(a.id, 'dateAcquired', e.target.value)} />
            <Input label="Supplier" value={a.supplier} onChange={e => updateField(a.id, 'supplier', e.target.value)} />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <RadioGroup 
              label="Was this newly purchased?" 
              options={[{ label: 'Newly Purchased', value: 'yes' }, { label: 'Second-hand/Other', value: 'no' }]}
              value={a.isNew}
              onChange={val => updateField(a.id, 'isNew', val)}
            />
            <Input label="Notes" value={a.notes} onChange={e => updateField(a.id, 'notes', e.target.value)} placeholder="Maintenance details..." />
          </div>
        </div>
      ))}
      <Button variant="outline" onClick={addAsset} className="w-full border-dashed py-5 bg-white/40">
        <SafeIcon icon={FiPlus} className="mr-2" /> Add Asset Record
      </Button>
    </div>
  );
};